export default value => {
  let temp
  try {
    temp = eval(value)
  } catch (e){
    return null
  }
  return temp
}

